// src/parser/csv.ts
import { csvParse } from "d3-dsv";
import json from "./json";
function csv(data, cfg) {
  const csvData = csvParse(data);
  return json(csvData, cfg);
}
export {
  csv as default
};
